import {h} from 'preact';

export default function TextInputBusiness({inputProps,  name, isRequired, errors}){
	return (
		<div className="form__item">
			<div className={`form-field form-field_gray ${errors ? 'form-field_state_error':''}`}>
				<label className="form-field__title" htmlFor={inputProps.id}>{isRequired}{name}</label>
				<input className="input form-field__input" type="text" placeholder='Введите данные' {...inputProps} autoComplete="off"/>
			</div>
		</div>
	)
}